import { BuilderElement, GlobalConfig, ElementType } from "../types/builder";
import { generateId } from "../utils/builder";
import { createListingSection } from "./template2";

// ====================== Notes Section ======================
const notes = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "notes-section",
  styles: {
    backgroundColor: "background",
    padding: "32px 16px",
    maxWidth: "1100px",
    margin: "0 auto",
  },
  responsiveStyles: {
    tablet: { padding: "32px 24px" },
    mobile: { padding: "24px 16px" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "notes-content",
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        marginBottom: "12px",
        padding: "0 16px",
      },
      responsiveStyles: {
        tablet: { marginBottom: "12px" },
        mobile: { marginBottom: "12px" },
      },
      children: [
        {
          id: generateId(),
          type: "heading" as ElementType,
          content: "It's Okay to Start Small...",
          styles: {
            fontSize: "44px",
            fontWeight: "bold",
            color: "#231f20",
            lineHeight: "1.2",
            marginBottom: "16px",
            letterSpacing: "-0.02em",
            fontFamily: "pro-display-bold, sans-serif",
          },
          responsiveStyles: {
            tablet: { fontSize: "44px" },
            mobile: { fontSize: "36px" },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "We get it - 3 extra bottles might've felt like too much right now. But before we wrap up your order, here's a lighter option.",
          styles: {
            fontSize: "24px",
            color: "#231f20",
            marginBottom: "16px",
            lineHeight: "1.5",
            fontWeight: "normal",
            letterSpacing: "-0.03em",
            fontFamily: "pro-display-regular, sans-serif",
          },
          responsiveStyles: {
            tablet: { fontSize: "20px", marginBottom: "16px" },
            mobile: { fontSize: "18px", marginBottom: "12px" },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            'Why not grab just 2 <span style="font-weight: bold; font-family: pro-display-bold, sans-serif;">more bottles</span> at the same VIP rate - no pressure, just one last little boost to keep your results going strong.',
          styles: {
            fontSize: "24px",
            color: "#231f20",
            lineHeight: "1.5",
            fontWeight: "normal",
            letterSpacing: "-0.03em",
            fontFamily: "pro-display-regular, sans-serif",
          },
          responsiveStyles: {
            tablet: { fontSize: "24px" },
            mobile: { fontSize: "20px" },
          },
        },
      ],
    },
  ],
});

// ====================== Features Box Section ======================
const featuresBoxSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "features-box",
  styles: {
    margin: "100px 0 30px",
    width: "100%",
  },
  responsiveStyles: {
    tablet: { margin: "60px 0 30px" },
    mobile: { margin: "30px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "container",
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 15px",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "features-box-container",
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "30px 0",
          },
          responsiveStyles: {
            mobile: { gap: "16px 0" },
          },
          children: [
            // Feature Box
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "feature-box",
              styles: {
                border: "1px solid #808285",
                width: "100%",
              },
              children: [
                // Feature Header
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  className: "feature-header",
                  styles: {
                    backgroundImage:
                      "linear-gradient(to right, #1e9dc8 60%, #65c6e7 80%, #37b4e1 90%)",
                    padding: "32px 0",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                  responsiveStyles: {
                    mobile: { padding: "16px 0" },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content:
                        "This is your ONLY chance to secure 2 extra bottles for just $39 each — over 43% OFF.",
                      styles: {
                        maxWidth: "926px",
                        color: "background",
                        textAlign: "center",
                        fontSize: "40px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "48px",
                        margin: "0",
                      },
                      responsiveStyles: {
                        mobile: { fontSize: "24px", lineHeight: "28px" },
                      },
                    },
                  ],
                },
                // Feature Body
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  className: "feature-body",
                  styles: {
                    padding: "40px",
                    backgroundColor: "#DBDBDB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      flexDirection: "column",
                      padding: "20px",
                      gap: "20px",
                    },
                    mobile: {
                      padding: "10px",
                      flexDirection: "column",
                      gap: "10px",
                    },
                  },
                  children: [
                    // Image Container
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      className: "img-container",
                      styles: {
                        flex: "1 1 calc(50% - 16px)",
                      },
                      responsiveStyles: {
                        mobile: { flex: "1 1 100%" },
                        tablet: { flex: "1 1 100%" },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/intellident/2 bottles (1).png",
                          alt: "2 Bottles of Intellident Pro",
                          styles: {
                            maxWidth: "90%",
                            width: "100%",
                            margin: "0 auto",
                          },
                          responsiveStyles: {
                            mobile: { maxWidth: "100%" },
                          },
                        },
                      ],
                    },
                    // Content Body
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      className: "content-body",
                      styles: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        gap: "30px 0",
                        flex: "1 1 calc(50% - 16px)",
                      },
                      responsiveStyles: {
                        mobile: {
                          gap: "16px 0",
                          flex: "1 1 100%",
                          width: "100%",
                          alignItems: "center",
                        },
                        tablet: {
                          flex: "1 1 100%",
                          width: "100%",
                          alignItems: "center",
                        },
                      },
                      children: [
                        // Feature List
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          className: "feature-list",
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            gap: "20px 0",
                          },
                          responsiveStyles: {
                            mobile: { gap: "16px 0" },
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                color: "#231F20",
                                fontSize: "24px",
                                fontStyle: "normal",
                                fontWeight: "600",
                                lineHeight: "26px",
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "flex-start",
                                gap: "0 10px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "22px",
                                  lineHeight: "30px",
                                },
                              },
                              children: [
                                {
                                  id: generateId(),
                                  type: "text" as ElementType,
                                  content: "🔥",
                                  styles: {},
                                },
                                {
                                  id: generateId(),
                                  type: "text" as ElementType,
                                  content:
                                    "🔥 Get 2 more Bottles of Intellident Pro™ for just $78 Total (Only $39 Each!)",
                                  styles: {
                                    fontSize: "24px",
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    lineHeight: "26px",
                                  },
                                  responsiveStyles: {
                                    mobile: {
                                      fontSize: "16px",
                                      lineHeight: "20px",
                                    },
                                    tablet: {
                                      fontSize: "20px",
                                      lineHeight: "24px",
                                    },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        // CTA Button
                        {
                          id: generateId(),
                          type: "button" as ElementType,
                          className: "pay-btn",
                          content: "YES — Add 2 More Bottles for Just $78",
                          styles: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "12px 24px",
                            borderRadius: "14.568px",
                            backgroundImage:
                              "conic-gradient(from 72deg at 33.42% 100%, #f49d00 5.3999998793deg, #ffaf1a 196.2000060081deg, #fcc709 360deg)",
                            overflow: "hidden",
                            color: "#231F20",
                            textAlign: "center",
                            fontSize: "24px",
                            fontStyle: "normal",
                            fontWeight: "700",
                            lineHeight: "28px",
                            fontFamily: "SF Pro Display, sans-serif",
                          },
                          responsiveStyles: {
                            tablet: { alignSelf: "center" },
                            mobile: { fontSize: "16px", height: "50px" },
                          },
                        },
                        // Payment Methods
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: { textAlign: "center", width: "100%" },
                          children: [
                            {
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: { display: "flex", width: "100%" },
                              responsiveStyles: {
                                mobile: {
                                  justifyContent: "center",
                                  alignItems: "center",
                                },
                                tablet: {
                                  justifyContent: "center",
                                  alignItems: "center",
                                },
                              },
                              children: [
                                {
                                  id: generateId(),
                                  type: "container" as ElementType,
                                  styles: {
                                    position: "relative",
                                    display: "inline-block",
                                    width: "350px",
                                    padding: "0 8px",
                                    margin: "0 8px",
                                  },
                                  children: [
                                    {
                                      id: generateId(),
                                      type: "image" as ElementType,
                                      src: "/intellident/vector-1401.svg",
                                      alt: "Payment Methods Background",
                                      styles: { width: "100%" },
                                    },
                                    {
                                      id: generateId(),
                                      type: "container" as ElementType,
                                      styles: {
                                        position: "absolute",
                                        inset: 0,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px",
                                        padding: "8px",
                                        top: "-12px",
                                      },
                                      children: [
                                        {
                                          id: generateId(),
                                          type: "paragraph" as ElementType,
                                          content: "GUARANTEED SAFE CHECKOUT",
                                          styles: {
                                            fontSize: "12px",
                                            marginTop: "-16px",
                                            letterSpacing: "-0.01em",
                                            lineHeight: "1",
                                          },
                                        },
                                        {
                                          id: generateId(),
                                          type: "container" as ElementType,
                                          styles: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px",
                                          },
                                          children: [
                                            {
                                              id: generateId(),
                                              type: "image" as ElementType,
                                              src: "/intellident/Asset7.webp",
                                              alt: "McAfee",
                                              styles: { height: "20px" },
                                            },
                                            {
                                              id: generateId(),
                                              type: "image" as ElementType,
                                              src: "/intellident/clip-path-group-4.webp",
                                              alt: "PayPal",
                                              styles: { height: "20px" },
                                            },
                                            {
                                              id: generateId(),
                                              type: "image" as ElementType,
                                              src: "/intellident/kamqdp-1.webp",
                                              alt: "Visa",
                                              styles: { height: "20px" },
                                            },
                                            {
                                              id: generateId(),
                                              type: "image" as ElementType,
                                              src: "/intellident/Asset 7.webp",
                                              alt: "American Express",
                                              styles: { height: "20px" },
                                            },
                                            {
                                              id: generateId(),
                                              type: "image" as ElementType,
                                              src: "/intellident/rectangle-1.webp",
                                              alt: "MasterCard",
                                              styles: { height: "20px" },
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            // Feature Box Text
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              className: "feature-box-text",
              content:
                '<a href="#">No thanks, I\'ll pass on this special offer</a>',
              styles: {
                color: "forground",
                textAlign: "center",
                fontSize: "22px",
                fontStyle: "italic",
                fontWeight: "400",
                lineHeight: "100%",
                fontFamily: "SF Pro Display, sans-serif",
                margin: "0",
                textDecoration: "underline",
              },
              responsiveStyles: {
                mobile: { fontSize: "16px" },
              },
            },
          ],
        },
      ],
    },
  ],
});

// ====================== Message Section (Image + Thank You) ======================
const messageSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "msg-box",
  styles: {
    margin: "30px 0 100px",
    width: "100%",
  },
  responsiveStyles: {
    tablet: { margin: "30px 0 50px" },
    mobile: { margin: "30px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      className: "container",
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 16px",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          className: "msg-box-container",
          styles: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: "54px 0",
          },
          responsiveStyles: {
            tablet: { gap: "30px 0" },
            mobile: { gap: "20px 0" },
          },
          children: [
            // Doctor Image
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "400px",
                height: "100%",
              },
              responsiveStyles: {
                tablet: { width: "100%", height: "100%" },
                mobile: { width: "100%", height: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/intellident/doc1.webp",
                  alt: "Doctor",
                  styles: {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  },
                  responsiveStyles: {
                    tablet: {
                      maxWidth: "100%",
                      height: "100%",
                      objectFit: "contain",
                    },
                    mobile: {
                      maxWidth: "100%",
                      height: "100%",
                      objectFit: "cover",
                    },
                  },
                },
              ],
            },
            // Thank You Message
            {
              id: generateId(),
              type: "container" as ElementType,
              className: "pointers",
              styles: {
                display: "flex",
                alignItems: "stretch",
                justifyContent: "flex-start",
                flexDirection: "column",
                gap: "20px",
                flex: "1",
              },
              responsiveStyles: {
                tablet: { gap: "8px 0" },
              },
              children: [
                // Thanking Message
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  className: "thanking-msg",
                  content: "Thank you for ordering but…",
                  styles: {
                    color: "forground",
                    fontSize: "44px",
                    fontWeight: "700",
                    lineHeight: "100%",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "40px", textAlign: "center" },
                    mobile: { fontSize: "30px" },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "Thank you for beginning your journey with Intellident Pro™ - I truly appreciate your trust. One bottle is a strong start, but real neurological and oral transformation takes time. If you stop too early, your body may lose the momentum it's just starting to build. It's like rewiring the brain halfway, only to leave it unfinished.",
                  styles: {
                    color: "#231F20",
                    fontSize: "22px",
                    fontWeight: "400",
                    lineHeight: "1.2",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px", lineHeight: "28px" },
                    mobile: { fontSize: "16px", lineHeight: "24px" },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "I've seen it happen too often - people feel clearer, sharper, and more energized... then run out, and slowly regress. That's why I always recommend at least 90 days of consistent support to experience lasting results.",
                  styles: {
                    color: "#231F20",
                    fontSize: "22px",
                    fontWeight: "400",
                    lineHeight: "1.2",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px", lineHeight: "28px" },
                    mobile: { fontSize: "16px", lineHeight: "24px" },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "Right now, you have the rare opportunity to secure extra bottles at the deepest discount we'll ever offer. If you're able, grab them now - and protect the progress your body has already begun.",
                  styles: {
                    color: "#231F20",
                    fontSize: "22px",
                    fontWeight: "400",
                    lineHeight: "1.2",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "20px", lineHeight: "28px" },
                    mobile: { fontSize: "16px", lineHeight: "24px" },
                  },
                },
                // Signature
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  className: "signature",
                  content: "Dr. Michael Turner",
                  styles: {
                    fontSize: "1.875rem",
                    fontFamily: "Allura, cursive",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "30px", lineHeight: "42px" },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  className: "signature",
                  content: "Lead Researcher, Intellident Pro™",
                  styles: {
                    fontSize: "18px",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: { fontSize: "16px", lineHeight: "24px" },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});
const createScientificReferencesSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "100px 0 72px 0",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { margin: "72px 0 36px 0" },
    mobile: { margin: "40px 0 32px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0px",
      },
      responsiveStyles: {
        tablet: { gap: "18px" },
        mobile: { gap: "12px" },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Scientific References:",
          styles: {
            color: "forground",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "34px",
            fontWeight: 400,
            lineHeight: "80px",
            letterSpacing: "-1.35px",
            margin: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          responsiveStyles: {
            mobile: { fontSize: "22px", lineHeight: "25px" },
          },
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "35px",
            height: "100px",
          },
          responsiveStyles: {
            tablet: { gap: "24px", height: "auto" },
            mobile: { gap: "20px", height: "auto" },
          },
          children: [
            ...[1, 2, 3, 4].map((i) => ({
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: "258px",
                width: "100%",
              },
              responsiveStyles: {
                tablet: { maxWidth: "220px" },
                mobile: { maxWidth: "167px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/scientificReferencesSection1.png",
                  alt: `Reference Logo ${i}`,
                  styles: {
                    width: "100%",
                    objectFit: "contain",
                  },
                },
              ],
            })),
          ],
        },
      ],
    },
  ],
});

// ====================== Footer Section ======================
const createFooterSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  className: "footer-section",
  styles: { width: "100%" },
  children: [
    {
      id: generateId(),
      type: "paragraph" as ElementType,
      content: "Footer - customize as needed",
      styles: {
        textAlign: "center",
        color: "#888",
        fontSize: "16px",
        margin: 0,
      },
    },
  ],
});

export const template4Downsell = (globalConfig: GlobalConfig) => {
  return {
    notes: notes(globalConfig),
    featuresBox: featuresBoxSection(globalConfig),
    messageSection: messageSection(globalConfig),
    listing: createListingSection(globalConfig),
    scientificReferencesSection:
      createScientificReferencesSection(globalConfig),
    footer: createFooterSection(globalConfig),
  };
};
